import React from "react";
import styles from '../../styles/pages/contact-us.module.scss'
import { chatbotClicked } from "../../tracking/segment/footer";
import { getPageURL } from "../../utils/tracking";
import Section from "../common/Section";

const ContactBanner = () => {
    return(
            <Section className={styles.contactus__banner}>
            <div className={`${styles.contactus__banner} container`}>
                <div className={`${styles.row__top} row`} id="drop-email">
                        <div className={`${styles.row__center} col-12`}>
                            <p>Drop Us an Email!</p>
                        </div>
                        <div className={`${styles.row__width} row`}>
                            <div className={`${styles.row__right} col-12 col-lg-3 col-md-6`}>
                                    <h5>Business Queries</h5>
                                    <h6><a href="mailto:enquiry@onsite.co.in">enquiry@onsite.co.in</a></h6>
                            </div>
                            <div className={`${styles.item__top} col-12 col-lg-3 col-md-6`}>
                                    <h5>HR Queries</h5>
                                    <h6><a href="mailto:hr@onsite.co.in">hr@onsite.co.in</a></h6>
                            </div >
                            <div className={`${styles.item__top} col-12 col-lg-3 col-md-6`}>
                                    <h5>Support Queries</h5>
                                    <h6><a href="mailto:hr@onsite.co.in">help@onsite.co.in</a></h6>
                            </div >
                            <div className={`${styles.row__left} col-12 col-lg-3 col-md-6`}>
                                    <h5>Chat with Us</h5>
                                    <h6><a href="https://onst.in/4dCuJA" onClick={()=>{chatbotClicked({...getPageURL()})}} target="_blank" rel="noopener noreferrer">Launch Whatsapp</a></h6>
                                    {/* <h6 onClick={openChat}>Launch Fixie</h6> */}
                            </div>
                        </div>
                </div>
                </div>
                </Section>
    )
}
export default ContactBanner;